import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, OnInit, Type, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';

import { BottomPanelDirective } from './bottom-panel.directive';

@Component({
  selector: 'app-bottom-panel',
  templateUrl: './bottom-panel.component.html',
  styleUrls: ['./bottom-panel.component.css']
})
export class BottomPanelComponent implements OnInit {

  dynamicBottomComponent: any;

  @ViewChild(BottomPanelDirective) bottomPanelHost: BottomPanelDirective;

  subjectComponent: Subject<ComponentRef<any>>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}

  sidebarVisivel = false;
  overlayVisivel = false;


  ngOnInit(): void {
  }


  public carregarComponente(): void {
    const componentFactory = this.componentFactoryResolver
                                 .resolveComponentFactory(this.dynamicBottomComponent);

    const viewContainerRef = this.bottomPanelHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<any>(componentFactory);

    if ( this.subjectComponent ) {
      this.subjectComponent.next(componentRef);
    }
  }

  public toogle(): void {
    if ( this.sidebarVisivel ) {
      this.esconder();
    }
    else {
      this.exibir(null);
    }
  }

  private _onInit(): void {
    this.carregarComponente();
  }

  public exibir<T>(component: any): Subject<ComponentRef<T>> {
    this.subjectComponent = new Subject();

    if ( component ) {
      this.dynamicBottomComponent = component;
    }

    this.sidebarVisivel = true;
    this.overlayVisivel = true;

    setTimeout(() => {
      this._exibirOverlay();

      setTimeout(() => {
        this._exibirSidebar();

        // setTimeout(() => {
          this._onInit();
        // }, 500);

      }, 150);
    }, 100);

    return this.subjectComponent;
  }

  public esconder(): void {
    if ( this.subjectComponent ) {
      this.subjectComponent.complete();
      this.subjectComponent = null;
    }
    this.dynamicBottomComponent = null;

    setTimeout(() => {
      this._esconderSidebar();

      setTimeout(() => {
        this._esconderOverlay();

        setTimeout(() => {
          this.sidebarVisivel = false;
          this.overlayVisivel = false;
        }, 500);
      }, 200);
    }, 100);
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if ( this.sidebarVisivel ) {
      this.esconder();
    }
  }


  private _exibirSidebar(): void {
    document.getElementById('mat-drawer-container')
            .classList
            .remove('inativo');

    document.getElementById('mat-drawer-container')
            .classList
            .add('ativo');
  }

  private _exibirOverlay(): void {
    document.getElementById('overlay-container')
            .classList
            .remove('overlay-container-inativo');

    document.getElementById('overlay-container')
            .classList
            .add('overlay-container-ativo');
  }

  private _esconderSidebar(): void {
    document.getElementById('mat-drawer-container')
            .classList
            .remove('ativo');

    document.getElementById('mat-drawer-container')
            .classList
            .add('inativo');
  }

  private _esconderOverlay(): void {
    document.getElementById('overlay-container')
            .classList
            .remove('overlay-container-ativo');

    document.getElementById('overlay-container')
            .classList
            .add('overlay-container-inativo');
  }

}
